module.exports = __webpack_public_path__ + "static/media/Member_Account_icon.34d2b3bc.svg";